import React, {useState, useEffect} from "react";
import { GetCategoriesData, GetPackagesByIdData } from "../../../lib/data";
import { TopResultOfPackags, positionOfPackags, shapOfPackags } from "../../../lib/definitions";
import EditPackagesUi from "../../../ui/packagesUi/EditPackages";
import { useParams } from "react-router-dom";
import i18n from "../../../lib/i18n";


export default function EditPackages () {

    const {packageId} = useParams();
    const [categoriesData, setCategoriesData] = useState([]);
    const [packagesData, setPackagesData] = useState({});
    const t = i18n.t.bind(i18n); 

    useEffect(() => {
        handleApi();
    }, [])

    const handleApi = async () => {
        const params = [ {"status":"sub"} ];
        const categoryData = await GetCategoriesData(1, params);
        const packagesData = await GetPackagesByIdData(packageId);
        setPackagesData({})
        setCategoriesData([]);
        categoryData.data.map((e) => setCategoriesData((prev) => [...prev, e]));
        setPackagesData(packagesData);

    };

    const search = async (param) => {
        const params = [ {"name": param},{"status":"sub"} ];
        if(param){
            const categoriesDataFilter = await GetCategoriesData(1,params);
            setCategoriesData([]);
            categoriesDataFilter.data.map((e) => setCategoriesData((prev) => [...prev, e]));
        }
    };

    return(
        <div className="p-5 my-3 mx-6 rounded-lg bg-thirdly">
            <div>
                <h1 className="sm:text-[30px] text-[24px] text-center text-gray pt-1 sm:pb-8 pb-4">{t("edit_page_title.package")}</h1>
                <EditPackagesUi search={search} shapOfPackags={shapOfPackags} packagesData={packagesData} categoriesData={categoriesData} TopResultOfPackags={TopResultOfPackags} positionOfPackags={positionOfPackags}  />
            </div>
        </div>
    );
};